import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-incu-newsletters',
  templateUrl: './incu-newsletters.component.html',
  styleUrls: ['./incu-newsletters.component.css'],
})
export class IncuNewslettersComponent implements OnInit {
  private incubatornewsletterlistApi =
    environment.url + environment.incubnewsletterList;
  @Input() incubatorName: string = '';
  @Input() incubatorId: number = 0;
  constructor(private makeapi: ApiService) {}
  token;
  /**
   * Initializes the component.
   * Retrieves the token from session storage and calls the
   * `incNewsletterlistApi` method if the token is not null.
   */
  ngOnInit(): void {
    this.token = sessionStorage.getItem('jwttoken');
    if (this.token != null) {
      // Load the list of newsletters for the incubator
      this.incNewsletterlistApi();
    }
  }
  newsLetterList = [];
  newsLetterList2;
  list: any = {};
  sample = false;
  /**
   * Retrieves the list of newsletters from the API for the given incubator.
   * The list of newsletters is saved in the `newsLetterList` property.
   * The `sample` property is set to true when the API response is received.
   */
  incNewsletterlistApi() {
    const req2 = {
      // Pass the incubator ID to the API
      userId: this.incubatorId,
    };
    return this.makeapi
      .method(this.incubatornewsletterlistApi, req2, 'postunauth')
      .subscribe((data) => {
        // Save the list of newsletters
        this.newsLetterList = data.responsemodelList;
        // Set the sample flag to true
        this.sample = true;
      });
  }
}
